/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2019 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { createSelector } from 'reselect';
import { hasFeatureForEnv } from '@nebula/corona-floodgate-plugin';
import { getQueryVar } from '@nebula/rover';
import getEnv from '../env';

export const expiringSessions = hasFeatureForEnv('griffon-expiring-sessions', getEnv());
export const layouts = hasFeatureForEnv('griffon-layouts', getEnv());
export const quickConnect = hasFeatureForEnv('griffon-quick-connect', getEnv());
export const showAccessChanges = hasFeatureForEnv('griffon-show-access-changes', getEnv());
export const showColumnSettings = hasFeatureForEnv('griffon-plugin-column-settings', getEnv());
export const showTimeline = hasFeatureForEnv('griffon-h-timeline', getEnv());
export const pluginConfig = state =>
  hasFeatureForEnv('griffon-plugin-config', getEnv(), state) && !getQueryVar('workspace', state);
export const workspaces = state => getQueryVar('workspace', state);
export const validationPlugins = state =>
  hasFeatureForEnv('griffon-validation-plugins', getEnv(), state) && !getQueryVar('workspace', state);
export const configureWorkspaces = createSelector(
  workspaces,
  hasFeatureForEnv('griffon-configure-workspaces', getEnv()),
  (useWorkspaces, configureEnabled) => useWorkspaces && configureEnabled
);
export const versionsReleaseNotes = hasFeatureForEnv('griffon-versions-release-notes', getEnv());
